import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, AlertTriangle, Calendar, ClipboardList, Replace, ShieldPlus } from 'lucide-react';
export function Includes() {
  const items = [{
    icon: BookOpen,
    title: 'GUÍA PRINCIPAL: Recetas Caseras Saludables para Perros',
    description: 'Una guía práctica y visual con:',
    bullets: ['Recetas caseras simples para perros', 'Alimentos seguros organizados por categoría', 'Alimentos que debes evitar y por qué', 'Cómo armar un plato casero básico', 'Recetas de comidas y premios para perros', 'Consejos para introducir nuevos alimentos', 'Errores comunes al cocinar para perros', 'Menú de ideas para 7 días'],
    value: 19,
    isMain: true
  }, {
    icon: AlertTriangle,
    title: 'BONO 1: Póster Semáforo Canino de Ingredientes',
    description: 'Una herramienta visual imprimible para saber en segundos qué ingredientes puedes usar, cuáles dar con precaución y cuáles nunca deberías darle a tu perro. Incluye versión para cocina, nevera y celular.',
    value: 9,
    image: 'https://cdn.magicpatterns.com/uploads/eBPd9dPjc7m4iw5E7qEMX8/Bono_1.png'
  }, {
    icon: Calendar,
    title: 'BONO 2: Planificador Canino de 7 Días',
    description: 'Un planner imprimible para organizar recetas, lista de compras, preparación semanal y observaciones de tolerancia de tu perro durante una semana completa.',
    value: 12,
    image: 'https://cdn.magicpatterns.com/uploads/qStmRJSzYnNdX9MY4tSH5H/Bono_2.png'
  }, {
    icon: ClipboardList,
    title: 'BONO 3: Diario de Tolerancia Digestiva Canina',
    description: 'Un registro práctico para observar cómo responde tu perro a cada ingrediente nuevo durante 3 días, incluyendo energía, digestión, apetito y piel.',
    value: 9,
    image: 'https://cdn.magicpatterns.com/uploads/wHs72YptxuQgYSAQCaHPTN/Bono_3.png'
  }, {
    icon: Replace,
    title: 'BONO 4: Tarjetas de Sustitución Canina Express',
    description: 'Tarjetas imprimibles y recortables para reemplazar ingredientes de recetas cuando algo te falta en casa, sin improvisar de forma insegura.',
    value: 9,
    image: 'https://cdn.magicpatterns.com/uploads/8WbK6GiWVGeN3wCDwpZZ2m/Bono_4.png'
  }, {
    icon: ShieldPlus,
    title: 'BONO 5: Kit SOS Alimentario Canino',
    description: 'Una guía rápida para saber qué hacer si tu perro comió algo peligroso. Incluye lista roja de alimentos, síntomas de alerta, ficha de emergencia imprimible y script listo para llamar al veterinario.',
    value: 12,
    image: 'https://cdn.magicpatterns.com/uploads/wMoaerkLwjCyUvyrou2uKa/Bono_5.png'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-107">
            Esto es exactamente lo que recibirás hoy:
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-108"></div>
        </div>

        <div className="space-y-8" data-id="element-109">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-3xl p-6 md:p-8 shadow-soft border ${item.isMain ? 'border-brand-orange ring-2 ring-brand-orange/20' : 'border-gray-100'}`} data-id="element-110">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-111">
                {item.image ? <img src={item.image} alt={item.title} className="w-full md:w-44 lg:w-52 shrink-0 rounded-2xl object-cover shadow-md border border-brand-beige" loading="lazy" data-id="element-112" /> : <div className={`p-4 rounded-2xl shrink-0 ${item.isMain ? 'bg-brand-orange text-white' : 'bg-brand-beige text-brand-navy'}`} data-id="element-113">
                    <item.icon className="w-8 h-8" data-id="element-114" />
                  </div>}
                <div className="flex-1" data-id="element-115">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4" data-id="element-116">
                    <h3 className={`text-xl md:text-2xl font-bold ${item.isMain ? 'text-brand-orange' : 'text-brand-navy'}`} data-id="element-117">
                      {item.title}
                    </h3>
                    <span className="inline-block bg-green-100 text-green-800 font-bold px-3 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-118">
                      Valor: ${item.value} USD
                    </span>
                  </div>
                  <p className="text-gray-700 text-lg mb-4" data-id="element-119">
                    {item.description}
                  </p>

                  {item.bullets && <ul className="grid md:grid-cols-2 gap-3 mt-6" data-id="element-120">
                      {item.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 text-gray-600" data-id="element-121">
                          <span className="text-brand-orange font-bold mt-0.5" data-id="element-122">
                            →
                          </span>
                          {bullet}
                        </li>)}
                    </ul>}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-brand-navy text-white rounded-3xl p-8 text-center max-w-2xl mx-auto shadow-xl" data-id="element-123">
          <div className="space-y-2 mb-8" data-id="element-124">
            <p className="text-xl text-gray-400 line-through" data-id="element-125">
              Valor total del pack: $70 USD
            </p>
            <p className="text-3xl md:text-4xl font-bold text-brand-gold" data-id="element-126">
              Precio de lanzamiento: solo $6.36 USD
            </p>
          </div>
          <a href="https://noveliahub.com/cart/51019183030308:1" className="inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full bg-brand-orange text-white hover:bg-brand-orangeHover" data-id="element-127">
            Quiero el pack completo por $6.36 →
          </a>
        </motion.div>
      </div>
    </section>;
}